<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { pbAuthBase } from 'pb-components'
import AuthService from '@/services/auth'
import { processStatuses } from '@/utils'

const route = useRoute()
const status = ref(processStatuses.LOADING)

const goBack = () => {
  window.close()
}

// Hands the organizer's SelfServe session to the event site: the backend checks they administer
// the event and returns the event site's SSO callback, which lands on returnUrl once signed in.
onMounted(async () => {
  const { eventId, returnUrl } = route.query
  try {
    const { data } = await AuthService.generateSsoRedirectUrl({ eventId: Number(eventId) })
    const url = new URL(data.redirectUrl)
    if (returnUrl) {
      url.searchParams.append('returnUrl', returnUrl)
    }
    window.location.replace(url.href)
  } catch (e) {
    console.error(e)
    status.value = processStatuses.ERROR
  }
})
</script>

<template>
  <pb-auth-base :status="status"
                :error-action="goBack">
  </pb-auth-base>
</template>
